import React from 'react';
import {
  Datagrid,
  DateInput,
  downloadCSV,
  Filter,
  List,
  TextField,
} from 'react-admin';
import moment from 'moment';
import jsonExport from 'jsonexport/dist';
import PriceField from '../coupons/PriceField';
import { getServiceEntity } from '../../helper';

const exporter = (items) => {
  const formatPrice = (amt) => `$${amt.toFixed(2)}`;

  const itemsForExport = items.map((item) => {
    return {
      scheduled_work_id: item.scheduled_work_id,
      date: item.date,
      postal_code: item.customer_address?.postal_code,
      service_vehicle_id: item.service_vehicle_id,
      tax_rate_percent: item.tax_rate_percent,
      sales_tax_dollars: formatPrice(item.sales_tax_dollars),
      amount_paid_dollars: formatPrice(item.amount_paid_dollars),
      total_taxed_price_dollars: formatPrice(item.total_taxed_price_dollars),
    };
  });

  const columns = [
    'Scheduled Work Id',
    'Date',
    'Postal Code',
    `${getServiceEntity()} ID`,
    'Tax Rate Percent',
    'Sales Tax',
    'Amount Paid',
    'Total Taxed Price',
  ];
  jsonExport(
    itemsForExport,
    {
      rename: columns,
    },
    (err, csv) => {
      downloadCSV(csv, 'sales-tax-report'); // download as 'sales-tax-report.csv` file
    },
  );
};

const ScheduledWorkFilter = (props) => (
  <Filter {...props}>
    <DateInput source="start_date" alwaysOn />
    <DateInput source="end_date" alwaysOn />
  </Filter>
);

const SalesTaxReport = () => {
  return (
    <List
      exporter={exporter}
      hasList={false}
      hasShow={false}
      hasCreate={false}
      hasEdit={false}
      resource="scheduled-work"
      basePath="scheduled-work"
      title="Sales Tax Report"
      filterDefaultValues={{
        start_date: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end_date: moment()
          .endOf('month')
          .format('YYYY-MM-DD'),
      }}
      filters={<ScheduledWorkFilter />}
      sort={{ field: 'date', order: 'ASC' }}
      bulkActionButtons={false}
      perPage={50}
    >
      <Datagrid>
        <TextField source="scheduled_work_id" />
        <TextField source="date" />
        <TextField source="customer_address.postal_code" />
        <TextField source="tax_rate_percent" />
        <PriceField source="total_taxed_price_dollars" />
        <PriceField source="amount_paid_dollars" />
        <PriceField source="sales_tax_dollars" />
      </Datagrid>
    </List>
  );
};

export default SalesTaxReport;
